module.exports = __webpack_public_path__ + "img/zhong.c88cd3fc.png";